import { motion } from 'framer-motion';
import styled from 'styled-components';

import { fadeTransition, FadeVariant, fadeVariants } from '@pkg/motion';
import { styledTypography } from '@pkg/primitives';

import { tokens } from './FieldLimitOutput.tokens';

interface StyledFieldLimitOutputProps {
    $color?: string;
}

export const StyledFieldLimitOutput = styled(motion.output).attrs({
    variants: fadeVariants,
    initial: FadeVariant.Hidden,
    animate: FadeVariant.Show,
    exit: FadeVariant.Hidden,
    transition: fadeTransition,
})<StyledFieldLimitOutputProps>`
    --field-limit-output-color: ${({ $color }) => ($color ? $color : undefined)};
    display: grid;
    align-items: center;
    padding-left: ${tokens.padding}px;
    padding-right: ${tokens.padding}px;
    min-width: ${tokens.height + tokens.padding * 2}px;
    height: ${tokens.height}px;
    text-align: center;
    color: var(--field-limit-output-color, white);
    border: 2px solid currentColor;
    border-radius: ${tokens.radius}px;
`;

export const Label = styled.p`
    ${styledTypography.allianceBase};
    ${styledTypography.textBoxTrim};
    display: block;
    font-size: ${tokens.fontSize}px;
    font-weight: 700;
    color: currentColor;
`;
